<template>
  <div v-if="response"
  >

    <document-container
      v-if="isOWL"
      :logo="logo"
      documentType="tmc-export"
    >
      <div
        slot="raw-header"
      >
        <img :src="logo" alt="" class="logo">

        <div class="header">
          <pagetitle
            :data="{title: `Produktprüfung und Freigabe eines Finanzinstruments`}"
          ></pagetitle>
        </div>

      </div>
      <div
        slot="raw-body"
        class="page-block"
      >
        <table class="table is-narrow">
          <tbody>
          <tr>
            <td>Datum</td>
            <td>{{ new Date().toLocaleDateString('de') }}</td>
          </tr>
          <tr>
            <td>Empfehlung</td>
            <td>Kaufen</td>
          </tr>
          <tr>
            <td>Produktname</td>
            <td>{{ response[0].checkResult.product.name }}</td>
          </tr>
          <tr>
            <td>WKN / ISIN</td>
            <td>{{ response[0].checkResult.product.ids.wkn }} / {{ response[0].checkResult.product.ids.isin }}</td>
          </tr>
          <tr>
            <td>Vorabprüfung auf vorliegende Interessenkonflikte zum Emittent, Produktintervention der BaFin
            </td>
            <td>Zu Emittenten BNP, DZ BANK HSBC, UBS, Vontobel vorab zentral erfolgt</td>
          </tr>
          <tr>
            <td>Marktmeinung/Begründung/Chancen</td>
            <td>Siehe Erläuterung in der Geeignetheitserklärung</td>
          </tr>
          <tr>
            <td>Risiken</td>
            <td> Siehe PIF</td>
          </tr>
          <tr>
            <td>Anlageform/-rhythmus</td>
            <td>[&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;] Einmalige Anlage</td>
          </tr>
          <tr>
            <td>Assetklasse</td>
            <td>100% Substanzwerte</td>
          </tr>
          <tr>
            <td>PAI/ OffenlegVO/ TaxVO</td>
            <td> Siehe Tabelle</td>
          </tr>
          <tr>
            <td>Prüfung von PIF/BIB
            </td>
            <td>durchgeführt
            </td>
          </tr>
          <tr>
            <td>Bail-in-fähiges Finanzinstrument (Gläubigerbeteiligung)
            </td>
            <td>ja
            </td>
          </tr>
          <tr>
            <td>Äquivalenzprüfung</td>
            <td>Vorab systemseitig erfolgt</td>
          </tr>
          <tr>
            <td>
              Ergebnis der Zielmarktprüfung
            </td>
            <td v-if="response[0].checkResult.tmc.conflict" style="border-bottom: none">Kriterien nicht erfüllt</td>
            <td v-if="!response[0].checkResult.tmc.conflict" style="border-bottom: none">Kriterien erfüllt</td>
          </tr>
          <tr>
            <td>Kundennummer</td>
            <td style="border: 1px dashed #294b88">
              {{ response[0].checkResult.comment || '—' }}<br><br>Hinweis zur Abwicklung: Textschlüssel 101_ außerhalb
              der Hausmeinung nutzen. Ablage im Kundenarchiv
            </td>
          </tr>
          <tr>
            <td>
              <br>Produktfreigabe erteilt
            </td>
            <td>
              <br>Mitarbeiter / User-ID:
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </document-container>

    <document-container
      v-for="product in response"
      :key="product.checkResult.product.ids.isin"
      :logo="logo"
      documentType="tmc-export"
    >

      <div
        slot="raw-header"
      >
        <img :src="logo" alt="" class="logo">

        <div class="header">
          <pagetitle
            v-if="!isOWL"
            :data="{title: product.checkResult.product.name || (product.checkResult.product.enriched ? product.checkResult.product.enriched.displayName : false) || product.checkResult.product.ids.isin}"
          ></pagetitle>

          <pagetitle
            v-if="isOWL"
            :data="{title: `Produktprüfung und Freigabe eines Finanzinstruments`}"
          ></pagetitle>
        </div>

      </div>

      <div
        slot="raw-body"
        class="page-block"
      >
        <div class="tmc-info">
          <div>
            <strong>WKN:</strong> {{ product.checkResult.product.ids.wkn }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>ISIN:</strong> {{ product.checkResult.product.ids.isin }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>Stand:</strong> {{ time }}
            <template v-if="product.customData.name">&nbsp;&nbsp;|&nbsp;&nbsp;
              <strong>Kunde:</strong> {{ product.customData.name }}
            </template>
          </div>
          <template v-if="product.checkResult.tmc.displayInfoText">
            <br>
            <i
              :class="`fa ${product.checkResult.tmc.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'}`"></i>
            {{ product.checkResult.tmc.info }}
          </template>
        </div>

        <table class="table is-narrow">
          <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:40%">{{ product.checkResult.product.label}}</th>
            <th style="width:40%">{{ product.checkResult.reference.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in product.checkResult.tmc.criteria"
              :class="row.conflict ? 'tmc-row-conflict': 'tmc-row-success'">
            <td>
              <i :class="`fa ${row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'}`"></i>
              &nbsp;
              {{ row.label }}
            </td>
            <td>
              <i :class="row.positive ? 'tmc-success' : 'tmc-neutral'" class="fa fa-plus-circle"></i>
              {{ row.positive ? row.positive.join(', ') : '—' }}
              <br>
              <i :class="row.negative ? 'tmc-error' : 'tmc-neutral'" class="fa fa-minus-circle"></i>
              {{ row.negative ? row.negative.join(', ') : '—' }}
            </td>

            <td v-if="$route.query.mode === 'REFERENCE_TMC_GROUP'">
              <i :class="row.referencePositive ? 'tmc-success' : 'tmc-neutral'" class="fa fa-plus-circle"></i>
              {{ row.referencePositive ? row.referencePositive.join(', ') : '—' }}
              <br>
              <i :class="row.referenceNegative ? 'tmc-error' : 'tmc-neutral'" class="fa fa-minus-circle"></i>
              {{ row.referenceNegative ? row.referenceNegative.join(', ') : '—' }}
            </td>

            <td v-if="$route.query.mode === 'REFERENCE_PROVIDER' || $route.query.mode === 'CUSTOMER'">
              <template v-if="row.referencePositive">{{ row.referencePositive.join(', ') }}</template>
              <template v-else>—</template>
            </td>
          </tr>
          </tbody>
        </table>

      </div>

      <div
        v-if="['TMC_SUSTAINABILITY', 'TMC_SUSTAINABILITY_SUITABILITY'].includes(product.checkVisibilityMode)"
        slot="raw-body"
        class="page-block"
      >
        <div class="tmc-info">
          <template v-if="product.checkResult.sustainability.displayInfoText">
            <i
              :class="`fa ${product.checkResult.sustainability.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'}`"></i>
            {{ product.checkResult.sustainability.info }}
          </template>
        </div>
        <table class="table is-narrow">
          <thead>
          <tr v-if="environment === 'hauck'">
            <th style="width:20%">Kategorie</th>
            <th style="width:40%">Ausprägung Produkt</th>
            <th style="width:40%">{{ product.checkResult.reference.label }}</th>
          </tr>
          <tr v-else>
            <th style="width:20%">Name</th>
            <th style="width:40%">Kriterien</th>
            <th style="width:40%">{{ product.checkResult.reference.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in product.checkResult.sustainability.criteria"
              :class="row.conflict ? 'tmc-row-conflict': 'tmc-row-success'">
            <td>
              <i :class="`fa ${row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'}`"></i> {{ row.label }}
            </td>
            <td>
              <template v-if="row.criteria && row.criteria.length !== 0">
                <div v-for="cell in row.criteria">{{ cell }}</div>
              </template>
              <template v-else>—</template>
            </td>
            <td>
              <template v-if="row.reference && row.reference.length !== 0">
                <div v-for="cell in row.reference">{{ cell }}</div>
              </template>
              <template v-else>—</template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="'TMC_SUSTAINABILITY_SUITABILITY' === product.checkVisibilityMode"
        slot="raw-body"
        class="page-block"
      >
        <div class="tmc-info">
          <template v-if="product.checkResult.suitability.displayInfoText">
            <i
              :class="`fa ${product.checkResult.suitability.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'}`"></i>
            {{ product.checkResult.suitability.info }}
          </template>
        </div>
        <table class="table is-narrow">
          <thead>
          <tr v-if="environment === 'hauck'">
            <th style="width:20%">Name</th>
            <th style="width:40%">Wertpapierrisikoklasse</th>
            <th style="width:40%">{{ product.checkResult.reference.label }}</th>
          </tr>
          <tr v-else>
            <th style="width:20%">Name</th>
            <th style="width:40%">Kriterien</th>
            <th style="width:40%">{{ product.checkResult.reference.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in product.checkResult.suitability.criteria"
              :class="row.conflict ? 'tmc-row-conflict': 'tmc-row-success'">
            <td>
              <i :class="`fa ${row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'}`"></i>
              &nbsp;
              {{ row.label }}
            </td>
            <td>
              <template v-if="row.criteria && row.criteria.length !== 0">{{ row.criteria.join(', ') }}</template>
              <template v-else>—</template>
            </td>
            <td>
              <template v-if="row.reference && row.reference.length !== 0">{{ row.reference.join(', ') }}</template>
              <template v-else>—</template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="product.esgPropertiesAreVisible"
        slot="raw-body"
        class="page-block"
      >
        <h2>Nachhaltigkeit</h2>
        <table class="table is-narrow">
          <tr v-for="(value,key) in esgTranslations">
            <td style="width:20%">{{ value }}</td>
            <td v-if="key !== 'paiCluster'">{{ product.checkResult.product.sustainability[key] || '—' }}</td>
            <td v-if="key === 'paiCluster'"
                v-html="product.checkResult.product.sustainability[key].join('<br>') || '---'"></td>
          </tr>
        </table>
      </div>
      <div
        v-if="!isOWL"
        slot="raw-body"
        class="page-block"
      >
        <h2>Kommentar</h2>
        <div>{{ product.checkResult.comment || '---' }}</div>
      </div>


    </document-container>

  </div>
</template>

<script>
import DocumentContainer from '../document/DocumentContainer'
import BlockMixin from '../block/BlockMixin'
import ProductService from "../../service/ProductService"
import TokenService from "../../service/TokenService"

export default {
  components: {
    DocumentContainer,
  },

  name: 'TmcExport',

  data() {
    return {
      response: null,
      template: null,
      esgTranslations: {
        preferencesTranslation: 'Präferenzen',
        focus: 'Schwerpunkt',
        labels: 'Labels',
        paiCluster: 'PAIs',
        esg: 'ESG',
        eco: 'ECO'
      }
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/test/style/tmc_export.css`,
        },
      ]
    },
  },

  props: {
    environment: {
      type: String,
    },
    dq: {
      type: String,
    },
    dqs: {
      type: String,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {},

  async created() {
    let token

    if (this.$route.query.token) {
      token = this.$route.query.token
    } else {
      token = await TokenService.checkToken()
    }

    if (this.dq) {
      ProductService.getTmcExport(
        this.environment,
        this.appInstance,
        token,
        {
          productDq: this.dq,
          mode: this.$route.query.mode,
          comment: this.$route.query.comment,
          referenceTmc: this.$route.query.tmc,
        },
      ).then(res => {
        this.response = res.data.data.length ? res.data.data : [res.data.data]
      })
    } else {
      ProductService.getMultiTmcExport(
        this.environment,
        this.appInstance,
        token,
        {
          productDqs: this.dqs.split('+'),
        },
      ).then(res => {
        this.response = res.data.data.length ? res.data.data : [res.data.data]
      })
    }
  },

  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    time() {
      return this.moment().format('DD. MMMM YYYY')
    },
    isOWL() {
      return this.appInstance === 'QQD3VPHD'
    },
  },
}
</script>

<style lang="scss">
.tmc-info {
  font-size: 14px;
  margin-bottom: 20px;

}

.tmc-row-conflict {
  background-color: #ffe7e7;
}


.tmc-neutral {
  color: #aaa;
  margin-right: 5px;
}

.tmc-success {
  color: green;
  margin-right: 5px;
}

.tmc-error {
  color: darkred;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// TmcExport.vue?6c0755c6